import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-wizard-steps',
  templateUrl: './wizard-steps.component.html',
  styleUrls: ['./wizard-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WizardStepsComponent implements OnInit {
  @Input() steps: string[] = [];
  @Input() currentStep: number = 0;

  constructor() {}

  ngOnInit(): void {}
}
